<template>
  <payin-details-settlement-dialog
    ref="modalSettlement"
  />
  <payin-datails-dialog
    ref="modal"
    @refund-click="$event => $emit('refund-click', $event)"
  />
</template>

<script setup>
import { ref } from 'vue';
import { getPayinById } from '@/apps/payin/payins/services/payins';
import { useErrorHandler } from '@/commons/composables/useErrorHandler';
import PayinDetailsSettlementDialog from '@/apps/payin/payins/components/PayinDetailsSettlementDialog.vue';
import PayinDatailsDialog from '@/apps/payin/payins/components/PayinDatailsDialog.vue';

defineProps({
  onOpenRefundDialog: {
    type: Function
  }
});
defineEmits(['refund-click']);

const modal = ref();
const modalSettlement = ref();
const { handleError } = useErrorHandler();

const open = async id => {
  try {
    const payin = await getPayinById(id);

    if (payin.category === 'settlement') {
      modalSettlement.value.open({ payin });
    } else {
      modal.value.open({ payin });
    }
  } catch (e) {
    handleError(e, 'Ocorreu um erro ao buscar o recebimento');
  }
};

const close = () => {
  modal.value.close();
};

defineExpose({
  open,
  close
});
</script>
